import React, { useState } from 'react';

const S = {
  sidebar:     { width: 200, background: 'white', borderRight: '1px solid #E4EDE8', position: 'fixed', top: 0, left: 0, height: '100vh', display: 'flex', flexDirection: 'column', zIndex: 100 },
  logo:        { padding: '16px', borderBottom: '1px solid #E4EDE8', fontSize: 15, fontWeight: 700, color: '#0D1F1A', flexShrink: 0 },
  logoSpan:    { color: '#075E54' },
  navItem:     { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', fontSize: 13, color: '#7A8F89', cursor: 'pointer', userSelect: 'none', flexShrink: 0 },
  navActive:   { background: '#F0F4F0', color: '#075E54', fontWeight: 600 },
  navSub:      { padding: '7px 16px 7px 44px', fontSize: 12, color: '#7A8F89', cursor: 'pointer', flexShrink: 0 },
  navSubActive:{ color: '#075E54', fontWeight: 600 },
  footer:      { padding: '8px 16px', fontSize: 11, color: '#7A8F89', textAlign: 'center', flexShrink: 0 },
};

const MENU = [
  { id: 'dashboard',     icon: '📊', label: 'Dashboard' },
  { id: 'tiendas',       icon: '🏪', label: 'Tiendas' },
  { id: 'negocios',      icon: '🏢', label: 'Negocios' },
  { id: 'planes',        icon: '📦', label: 'Planes' },
  { id: 'alertas',       icon: '🔔', label: 'Alertas' },
  //{ id: 'config',        icon: '⚙️',  label: 'Configuración' },
  { id: 'usuarios',      icon: '👥', label: 'Usuarios' },
];

export default function Sidebar({ paginaActiva, onNavegar, onCerrarSesion }) {
  const [reportesAbierto, setReportesAbierto] = useState(
    ['productos','ingresos','comisiones'].includes(paginaActiva)
  );

  return (
    <div style={S.sidebar}>
      <div style={S.logo}>
        <span style={S.logoSpan}>What</span>Market
        <div style={{ fontSize: 11, color: '#7A8F89', fontWeight: 400 }}>Superadmin</div>
      </div>

      {MENU.map(item => (
        <div key={item.id}
          style={{ ...S.navItem, ...(paginaActiva === item.id ? S.navActive : {}) }}
          onClick={() => onNavegar(item.id)}>
          <span>{item.icon}</span> {item.label}
        </div>
      ))}

      {/* Reportes expandible */}
      <div style={{ ...S.navItem, ...(reportesAbierto ? S.navActive : {}) }}
        onClick={() => setReportesAbierto(v => !v)}>
        <span>📈</span> Reportes
        <span style={{ marginLeft: 'auto', fontSize: 11 }}>{reportesAbierto ? '▲' : '▼'}</span>
      </div>
      {reportesAbierto && (
        <>
          <div style={{ ...S.navSub, ...(paginaActiva === 'productos' ? S.navSubActive : {}) }}
            onClick={() => onNavegar('productos')}>Productos vendidos</div>
          <div style={{ ...S.navSub, ...(paginaActiva === 'ingresos' ? S.navSubActive : {}) }}
            onClick={() => onNavegar('ingresos')}>Ingresos</div>
          <div style={{ ...S.navSub, ...(paginaActiva === 'comisiones' ? S.navSubActive : {}) }}
            onClick={() => onNavegar('comisiones')}>Comisiones</div>
        </>
      )}

        <div
        style={{ ...S.navItem, ...(paginaActiva === 'config' ? S.navActive : {}) }}
        onClick={() => onNavegar('config')}>
        <span>⚙️</span> Configuración
      </div>

      {/* Cerrar sesión */}
      <div style={{ borderTop: '1px solid #E4EDE8', marginTop: 12, flexShrink: 0 }}>
        <div style={{ ...S.navItem, color: '#A32D2D' }} onClick={onCerrarSesion}>
          <span>🚪</span> Cerrar sesión
        </div>
        <div style={S.footer}>ctrl.pixventa.com</div>
      </div>
    </div>
  );
}